import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import SnackbarDispatcher from './SnackbarDispatcher';
import { SNACKBAR_AUTOHIDE_DURATION, THEME_APP_NAME } from 'FRONTEND/utils/constants';

import './index.css';

export default (element, store) => {
  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            autoHideDuration={SNACKBAR_AUTOHIDE_DURATION}
            preventDuplicate
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          >
            <SnackbarDispatcher />
          </SnackbarProvider>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );
};
